import AdminButton from './AdminButton.jsx';

export default AdminButton;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/AdminControls/AdminButton/index.js